export default () => ({
  companyList: [],
  companyFilterList: [],
  company: null,
});
